<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedit"><em class="italic">To all who lost their lives during the ‘Finest Hour’</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?b426e884